





















import { Component, Vue, Prop } from 'vue-property-decorator'
import { copyDDLs, mergeDateRange, splitDateRange } from '@/configs/functions'
// import { enLookupType, enFirstType } from '@/configs/enums'
import { DDLItem } from '@/api/common/select'

import { namespace } from 'vuex-class'
import { enFirstType } from '@/configs/enums'
const DataSourceModule = namespace('dataSource')

@Component({
  components: {}
})
export default class DateSelector extends Vue {
  public name = 'DateSelector'

  //点击查询事件
  @Prop({ default: 0 })
  public selectId!: number
  @Prop({ default: '' })
  public start!: string
  @Prop({ default: '' })
  public end!: string
  //是否设置初始值
  @Prop({ default: true })
  public setDefault!: boolean
  //是否需要首选项, 默认不需要首选项
  @Prop({ default: false })
  public firstItem!: boolean

  get dateRange(): string[] {
    return mergeDateRange(this.start, this.end)
  }
  set dateRange(range: string[]) {
    const d = splitDateRange(range)
    this.start = d.start
    this.end = d.end
    this.emitData()
  }
  public defId: number = 0
  public showCustom: boolean = false

  public dateRangeList: DDLItem[] = []

  @DataSourceModule.Getter('dateSelector')
  public dateSource!: any

  public created() {
    // var data = Object.assign([], this.dataSource)
    var data = copyDDLs(this.dateSource, enFirstType.All)
    this.setSelectData(data)
  }
  public setSelectData(data: any) {
    if (!this.firstItem) {
      data.splice(0, 1)
    }
    this.dateRangeList = data
    if (this.setDefault) {
      var defItem = data.find((v: DDLItem) => v.ExInfo.Flag1 == true)
      if (defItem) {
        this.defId = defItem.Key
      }
      if (this.selectId == 0 && this.start == '') {
        if (this.defId == 0) {
          //判断是否有key=0的项
          var zeroItem = data.find((v: DDLItem) => v.Key == 0)
          if (zeroItem == null) {
            //如果没有首选项就设置第一项的值为默认值
            this.defId = data[0].Key
          }
        }
        this.selectId = this.defId
        // console.log('dateSelector default key=' + this.defId)
        this.emitData()
      }
    }
  }
  public mounted() {
    if (this.start != '') {
      this.showCustom = true
    }
  }
  public emitData() {
    this.$emit('update:selectId', this.selectId)
    this.$emit('update:start', this.start)
    this.$emit('update:end', this.end)
  }

  public changeMode() {
    this.showCustom = !this.showCustom
    this.start = this.end = ''
    this.selectId = 0
    if (!this.showCustom) {
      this.selectId = this.defId
    }
    this.emitData()
  }

  public $refs!: {
  }
}
